import { serviceActionsGenerator } from '../serviceGenerator'

const actionTypes = [
  '!FETCH_REPORTS',
  '!FETCH_ONBOARDING_TASKS',
  '!FETCH_PARTNER_DETAILS',
  '!FETCH_VAT_POSITION_REPORT',
  '!FETCH_BANK_TRANSACTIONS_REPORT',
  '!FETCH_AI_CHAT_DETAILS',
] as const

export default serviceActionsGenerator('reports', actionTypes)
